<div class="row">
  <div class="col-8">
    <h3 style="text-align: right; font-size: 25px;">Order Confirmation</h3>
  </div>
  <div class="col" style="text-align: right;" (click)="closeComponent(false)">
    <!-- <button mat-raised-button  style="color: white; background: red;">CLOSE</button> -->
    <i class="material-icons" style="cursor: pointer; font-size: 40px; color: red;">
      cancel
    </i>
  </div>
</div>
<br>
<div class="row" style="color: #7b8182; font-size: 21px;">
  <div class="col" style="text-align: right;">
    Order value
  </div>
  <div class="col-4" style="text-align: right;">{{order_amount | currency :'INR'}}</div>
  <div class="col-2"></div>
</div><br>
<div class="row" style="color: #7b8182;font-size: 21px;">
  <div class="col" style="text-align: right;">
    Current Balance in wallet
  </div>
  <div class="col-4" style="text-align: right;">
    {{wallet_balance | currency : 'INR'}}
  </div>
  <div class="col-2">
  </div>
</div>
<div class="row" *ngIf="wallet_balance > 0" style="color: #7b8182; text-align: center; font-size: 21px;">
  <div class="col" style="margin-top: 30px;">
    <mat-checkbox (change)="walletCheckboxChanged($event)" [(ngModel)]="is_wallet_selected"  [disabled]="true"
      style="font-size: 20px; border: 1px solid black;">
    </mat-checkbox> Use wallet balance to pay for this order
  </div>
</div>
<div class="row">
  <div class="col-12">
    <hr style="background-color: #b7b6b6">
  </div>
</div>
<div class="row" style="font-size: 21px; color: black;">
  <div class="col" style="text-align: right;">
    Amount payable
  </div>
  <div class="col-4" style="text-align: right;">{{final_price | currency :'INR'}}</div>
  <div class="col-2"></div>
</div>
<div class="row">
  <div class="col-12">
    <hr style="background-color: #b7b6b6">
  </div>
</div>
<div class="row">
  <div class="col" style="text-align: center;">
    <div class="col-2" *ngIf="disable_button">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    <button (click)="payClicked()" mat-raised-button class="button-class main-button" style="font-size: 23px;"
      [disabled]="disable_button" id="register_button">Continue to pay
      {{final_price | currency :'INR'}}</button>
  </div>
</div>
